import { type DocumentNode, gql } from '@apollo/client';

const verifyToken: DocumentNode = gql`
  mutation verifyToken($token: String!) {
    verifyToken(token: $token) {
      payload
    }
  }
`;

export default verifyToken;
